<template>
    <div id="page-content-wrapper">
        <div style="display: flex; justify-content: center; clear: both; margin-top: 20px;">
            <h1 style="text-align: center;">Trait-specific Tissue Calculation</h1>
        </div>

        <div style="font-size: 18px; text-align: center;">
            <a href="/#/results?id=229e8e6fce7944358d9de5d6ed737ded" >View Demo Results</a>
        </div>

        <el-row justify="center" type="flex">
            <el-col :span="23">
                <el-divider />
            </el-col>
        </el-row>

        <!-- 新增可折叠提示 -->
        <el-row>
            <el-col :span="22" :push="1">
                <el-card shadow="never" class="mb-3">
                    <div slot="header" style="display: flex; justify-content: space-between; cursor: pointer;" @click="showHelp = !showHelp">
                        <span style="font-size: 18px; font-weight: bold; color: #409EFF;">
                            <i class="el-icon-s-operation" style="margin-right: 8px;"></i>
                            Tooltip - Trait-specific Tissue Calculation
                            <i :class="showHelp ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" style="margin-left: 8px;"></i>
                        </span>
                        <el-tag type="primary" effect="dark">Click to View Tutorial</el-tag>
                    </div>
                    <div v-show="showHelp">
                        <el-alert 
                            v-for="(item, index) in helpContent"
                            :key="index"
                            :title="item"
                            :closable="false"
                            class="mb-2"
                            style="font-size: 16px; line-height: 1; padding: 5px 1px; background-color: #fff;"
                            effect="dark"
                        >
                            <template slot="title">
                                <span style="font-weight: 500; color: black;">
                                    <i class="el-icon-info" style="margin-right: 8px;"></i>
                                    {{ item }}
                                </span>
                            </template>
                        </el-alert>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="22" :push="1">
                <el-card shadow="never" class="mb-3">
                    <!--button-->

                    <!-- <h3>{{ activeRNA }}</h3> -->
                    <!-- <br /> -->

                    <!--文件-->
                    <el-row
                        :gutter="20"
                        class="mt-3"
                        style="margin-bottom: 20px"
                    >
                        <el-col :span="12">
                            <el-card shadow="never">
                                <div
                                    slot="header"
                                    style="display: flex; justify-content: space-between"
                                >
                                    <span>Choose File
                                        <a style="font-size: 16px;" href="http://www.geneasso.net/static/tissue.txt.gz">Download Example Data</a>
                                    </span>
                                    <el-tooltip content="Click 'Choose file' to select and upload your GWAS summary statistics file. Ensure it is in the correct format *.gz as specified by the GENEasso.">
                                        <i
                                            class="el-icon-question i-button"
                                        />
                                    </el-tooltip>
                                </div>
                                <el-upload
                                    ref="matrixUpload"
                                    action=""
                                    :on-change="handleUploadMatrix"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    style="width: 100%"
                                    accept=".gz"
                                >
                                    <el-input
                                        readonly
                                        :value="matrixFile.name || ''"
                                        placeholder="Select your GWAS Summary Statistics file in gz format."
                                        style="width: 100%"
                                    >
                                        <span slot="append">select file</span>
                                    </el-input>
                                </el-upload>
                                <el-progress v-if="uploadProgress" :percentage="uploadProgress"></el-progress>
                            </el-card>
                        </el-col>
                        <el-col :span="12">
                            <el-card shadow="never">
                                <div
                                    slot="header"
                                    style="display: flex; justify-content: space-between"
                                >
                                    <span>Separator
                                        <span style="color: red;font-weight: bold; font-size: 15px;">(After uploading your GWAS data, the separator is automatically detected. If it is not correct, please adjust it manually.)</span>
                                    </span>
                                    <el-tooltip content="Select the appropriate separator that corresponds to the delimiter used in your data （*.gz） file (e.g., comma, semicolon, tab).">
                                        <i
                                            class="el-icon-question i-button"
                                        />
                                    </el-tooltip>
                                </div>
                                <el-select
                                class="custom-select"
                                    v-model="selectedSeparator"
                                    filterable
                                    allow-create
                                    placeholder="Choose the delimiter used in your file."
                                >
                                    <el-option value="," label="," />
                                    <el-option value="tab" label="tab" />
                                    <el-option value="space" label="space" />
                                </el-select>
                            </el-card>
                        </el-col>
                    </el-row>
                    <el-row type="flex" align="middle">
                        <el-col :span="2">
                            <el-button
                                v-if="active === 0"
                                type="primary"
                                plain
                                class="mt-3 mb-3 float-left"
                                @click="handleLoadData"
                                >Load data</el-button
                            >
                        </el-col>
                        <el-col :span="10" style="height: 100%;">
                            <span style="color: red; font-weight: bold; margin-top: 30px; font-size: 15px;">Identifiers are auto-filled once you click 'Load Data'; please verify them for accuracy.</span>
                        </el-col>
                    </el-row>
                    <br />
                    <h4 style="color: red; font-weight: bold; font-size: 15px;">Fields marked with an asterisk (*) are required; all others are optional.</h4>
                    <br />
                    <el-form
                        :rules="ruleForm"
                        :model="formData"
                        ref="oneMainForm"
                        label-width="220px"
                    >
                        <el-row >
                            <el-row class="mt-3">
                                <el-col :span="12">
                                    <el-form-item label="Email" prop="email">
                                        <span slot="label">
                                            Email
                                            <el-tooltip content="Enter your email to receive job updates and a results link. If not provided, remember to save your job ID or bookmark the results page.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span>
                                        <el-input
                                            style="width: 80%;"
                                            v-model="formData.email"
                                            placeholder="Enter your email to receive job updates and a results link. If not provided, remember to save your job ID or bookmark the results page. "
                                        >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="rsID Identifier" prop="rsid">
                                        <!-- <span slot="label">
                                            rsID Identifier
                                            <el-tooltip content="Select the column header for rsIDs.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.rsid"
                                            filterable
                                            allow-create
                                            placeholder="Select the column header for rsIDs."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="P-Value Identifier" prop="pvalue">
                                        <!-- <span slot="label">
                                            P-Value Identifier
                                            <el-tooltip content="Pick the header for p-values.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.pvalue"
                                            filterable
                                            allow-create
                                            placeholder="Pick the header for p-values."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="Beta Identifier" prop="beta">
                                        <!-- <span slot="label">
                                            Beta Identifier
                                            <el-tooltip content="Identify the column for Beta values.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.beta"
                                            filterable
                                            allow-create
                                            placeholder="Identify the column for Beta values."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item
                                        label="Non Effect Allele Identifier"
                                        prop="nonEffectAllele"
                                    >
                                        <!-- <span slot="label">
                                            Non Effect Allele Identifier
                                            <el-tooltip content="If applicable, select the non-effect allele header.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.nonEffectAllele"
                                            filterable
                                            allow-create
                                            placeholder="If applicable, select the non-effect allele header."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">


                                    <el-form-item label="Chromosome Identifier" prop="chromosome">
                                        <!-- <span slot="label">
                                            Chromosome Identifier
                                            <el-tooltip content="Choose the header for chromosome numbers.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.chromosome"
                                            filterable
                                            allow-create
                                            placeholder="Choose the header for chromosome numbers."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item
                                        label="Effect Allele Identifier"
                                        prop="effectAllele"
                                    >
                                        <!-- <span slot="label">
                                            Effect Allele Identifier
                                            <el-tooltip content="Select the effect allele column header.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.effectAllele"
                                            filterable
                                            allow-create
                                            placeholder="Select the effect allele column header."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item
                                        label="Genomic Position Identifier"
                                        prop="genomicPosition"
                                    >
                                        <!-- <span slot="label">
                                            Genomic Position Identifier
                                            <el-tooltip content="Pick the genomic position header.">
                                                <i class="el-icon-question i-button" />
                                            </el-tooltip>
                                        </span> -->
                                        <el-select
                                        class="custom-select"
                                            v-model="formData.genomicPosition"
                                            filterable
                                            allow-create
                                            placeholder="Pick the genomic position header."
                                        >
                                            <el-option
                                                v-for="item in columnList"
                                                :value="item"
                                                :label="item"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-row>
                        <br />

                        <el-row class="mt-3">
                            <el-col class="text-center">
                                <el-button type="success" @click="ok" key="ok"
                                    >Submit</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>

const buttonList = [
    { label: "miRNA", value: "" },
    { label: "mRNA", value: "" },
    { label: "tRNA", value: "" },
    { label: "Other", value: "" },
];

const checkboxMethodList = [
    { label: "No normalization, just visualization", value: "miRNA" },
    { label: "Counts per Million", value: "miRNA" },
    { label: "Upper Quartile", value: "miRNA" },
    { label: "Median", value: "miRNA" },
    { label: "TMM", value: "miRNA" },
    { label: "Quantile", value: "miRNA" },
    { label: "Relative Log Expression", value: "miRNA" },
    { label: "Remove Unwanted Variation - RUVs", value: "miRNA" },
];

const baseConfig = {
    method: "",
    numberOfPValueThreshold: "",
    windowSize: "",
    r2: "",
    bimFileId: "",
    famFileId: "",
    bedFileId: "",
    phenoFileId: "",
    bimFile: {},
    famFile: {},
    bedFile: {},
    phenoFile: {},
    bimFileProgress: 0,
    famFileProgress: 0,
    bedFileProgress: 0,
    phenoFileProgress: 0,
};


export default {
    name: "query",
    components: { },

    data() {
        return {
            activeBtn: "",
            matrixFile: {},
            annotationFile: {},
            checkboxMethods: [],
            buttonList,
            checkboxMethodList,
            activeRNA: "tRNA",
            active: 0,
            fileId: "",
            selectedSeparator: "",
            columnList: [],
            chocseItem: "",
            isDataLoaded: false,
            methodList: ['CT', 'SCT', 'LDpred2-sp', 'LDpred2-nosp', 'LDpred2-auto', 'LDpred2-inf', 'DBSLMM', 'DBSLMM-auto', 'DBSLMM-lmm', 'SBLUP', 'PRScs-auto', 'PRScs-tuning', 'SBayesR', 'lassosum'],

            formData: {
                method: [],
            },
            // 验证规则
            ruleForm: {
                rsid: [{ required: true, message: "rsID Identifier not empty", trigger: "blur" }],
                beta: [{ required: true, message: "Beta Identifier not empty", trigger: "blur" }],
                pvalue: [
                    { required: true, message: "P-Value Identifier not empty", trigger: "blur" },
                ],
                // email: [{ required: true, message: "Email cannot be empty", trigger: "blur" }],
                sampleSize: [{ required: true, message: "Sample size Identifier not empty", trigger: "blur" }],
                ancestry: [{ required: true, message: "Ancestry not empty", trigger: "blur" }],
                chromosome: [{ required: true, message: "Chromosome not empty", trigger: "blur" }],
                nonEffectAllele: [{ required: true, message: "NonEffectAllele not empty", trigger: "blur" }],
                effectAllele: [{ required: true, message: "EffectAllele not empty", trigger: "blur" }],
                genomicPosition: [{ required: true, message: "GenomicPosition not empty", trigger: "blur" }],
                includingUkbb: [
                    {
                        required: true,
                        message: "Including UKBB individuals not empty",
                        trigger: "blur",
                    },
                ],
                sexSpecific: [
                    { required: true, message: "Sex specific not empty", trigger: "blur" },
                ],
            },
            rules: [
                { required: true, message: 'Identifier not empty'},
            ],
            // 任务ID
            taskId: "",
            formDataB: {
                jobId: "",
                methodList: [],
                methodConfList: [],
            },
            tempParams: {},
            uploadProgress: 0,
            showHelp: false,
            helpContent: [
            "This step-by-step guide will walk you through using this feature to identify the tissues that may causally contribute to the diseases studied in your GWAS summary statistics.",
            "Step 1. Ensure that your GWAS summary statistics file is formatted correctly with the necessary identifiers. Required fields include rsID, P-value, Beta, Non-Effect Allele Identifier, and Effect Allele Identifier. Optional fields are Chromosome and Genomic Position. The file should be in a compressed .gz format for efficient processing.",
            "Step 2: Data Upload. lick 'Choose File' to upload your GWAS summary statistics file from your local computer. After selection, click 'Load data' to import your file into the system.",
            "Step 3: Configuring File Separator. Choose the appropriate separator that matches the one used in your file, such as a comma, semicolon, or tab.",
            "Step 4: Setting Identifiers. In the dropdown menus provided, select the column headers from your file that correspond to the required identifiers.",
            "rsID Identifier: The column header for the Reference SNP cluster ID.",
            "P-Value Identifier: The column header for the P-values.",
            "Beta Identifier: The column header for the Beta values indicating effect sizes.",
            "Effect Allele Identifier: The column header for the Effect Allele.",
            "Non-Effect Allele Identifier: The column header for the Non-Effect Allele.",
            "Select additional identifiers for Chromosome and Genomic Position if present in your file.",
            "Step 5: Analysis Submission. With all fields accurately completed, click the 'Submit' button to initiate the analysis. GENEasso will analyze the provided data to identify the Trait-specific Tissues involved in the disease mechanisms indicated by your GWAS data.",
            "Step 6: Job Submission and Results Notification Upon submission of your data for analysis, you will immediately receive a unique job ID. Make note of this job ID as it is essential for tracking the progress of your analysis.",
            "A confirmation, including your job ID, will also be sent to your provided email address.",
            "You can use the job ID to check the status of your job at any time on the webserver.",
            "When your job is completed, you will receive another email notification. This email will contain a direct link to the results webpage. On the results page, you will be able to view the final analysis and identify the Trait-specific Tissue for your GWAS data. This is done by selecting the minimum p-value across all GTEx tissues, which will highlight the most significant tissue associations.",
            ],
        };
    },

    methods: {
        handleCheckboxMethod(list) {
            let obj = {};
            list.forEach((key) => {
                obj[key] = this.tempParams[key] || Object.assign({}, baseConfig);
            });
            this.tempParams = obj;
        },

        async handleStepNext() {
            await this.$refs.oneMainForm.validate();

            if (this.active === 0) {
                await this.handlePreCreateJob();
            }

            if (this.active < 1) this.active++;
        },

        async handleLoadData() {
            if (!this.matrixFile.raw) {
                this.$message({
                    message: "Please choose file",
                    type: "error",
                });
                return;
            }

            await this.ob_meta_parse();
            this.isDataLoaded = true;

            await this.parseConf();
        },

        // 最终上传文件
        async ok() {
            await this.$refs.oneMainForm.validate();

            for (const key of Object.keys(this.tempParams)) {
                this.tempParams[key].bimFile.raw &&
                    (this.tempParams[key].bimFileId = await this.uploadFile(
                        this.tempParams[key].bimFile.raw, (e) => {
                            this.tempParams[key].bimFileProgress = Math.floor((e.loaded * 100) / e.total);
                        }
                    ));

                this.tempParams[key].famFile.raw &&
                    (this.tempParams[key].famFileId = await this.uploadFile(
                        this.tempParams[key].famFile.raw, (e) => {
                            this.tempParams[key].famFileProgress = Math.floor((e.loaded * 100) / e.total);
                        }
                    ));

                this.tempParams[key].bedFile.raw &&
                    (this.tempParams[key].bedFileId = await this.uploadFile(
                        this.tempParams[key].bedFile.raw, (e) => {
                            this.tempParams[key].bedFileProgress = Math.floor((e.loaded * 100) / e.total);
                        }
                    ));

                this.tempParams[key].phenoFile.raw &&
                    (this.tempParams[key].phenoFileId = await this.uploadFile(
                        this.tempParams[key].phenoFile.raw, (e) => {
                            this.tempParams[key].phenoFileProgress = Math.floor((e.loaded * 100) / e.total);
                        }
                    ));

                this.tempParams[key].method = key;
            }

            this.formDataB.methodConfList = Object.values(this.tempParams);

            let data = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
                conf: this.formData,
            };

            const res = await this.$ajax.post("/job/tissue/create", data);
            if (res.code === 200) {
                this.$message.success("Submit success");
                setTimeout(() => {
                    this.$router.push({
                        path: `/results?id=${res.data}`,
                    });
                }, 1000 * 2);
            } else {
                this.$message.error(res.message);
            }
        },

        async handlePreCreateJob() {
            // 存储文件
            let data = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
                conf: this.formData,
            };

            const res = await this.$ajax.post("/job/pre_create", data);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.taskId = res.data;
            this.formDataB.jobId = this.taskId;
        },

        async ob_meta_parse() {
            const params = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
            };

            const res = await this.$ajax.post("job/meta/parse", params);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.columnList = res.data.columnList;
        },

        async getSeparator(attachmentId) {
            const params = {
                attachmentId,
            };

            const res = await this.$ajax.post("job/meta/separator", params);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.selectedSeparator = res.data
        },

        async parseConf() {
            const params = {
                attachmentId: this.fileId,
                separator: this.selectedSeparator,
            };

            const res = await this.$ajax.post("job/meta/conf/parse", params);
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.formData = res.data
        },

        async uploadFile(file, callback) {
            const params = new FormData();
            params.append("file", file);
            console.log(callback)
            const res = await this.$ajax.upload("attachment/upload", params, {
                onUploadProgress: callback || ((progressEvent) => {
                    this.uploadProgress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
                }),
            });
            if (res.code !== 200) {
                this.$message.error(res.message);
                return;
            }
            this.uploadProgress = 0;

            await this.getSeparator(res.data);

            return res.data;
        },

        handleStepPrev() {
            if (this.active > 0) this.active--;
        },

        async handleUploadMatrix(file) {
            this.$refs["matrixUpload"].clearFiles();
            this.matrixFile = file;

            this.fileId = await this.uploadFile(this.matrixFile.raw);

            this.isDataLoaded = false;
        },

        handleUploadFam(obj) {
            return (file) => {
                obj.famFile = file;
            };
        },

        handleUploadBed(obj) {
            return (file) => {
                obj.bedFile = file;
            };
        },

        handleUploadBim(obj) {
            return (file) => {
                obj.bimFile = file;
            };
        },

        handleUploadPheno(obj) {
            return (file) => {
                obj.phenoFile = file;
            };
        },

        handleUploadAnnotation(file) {
            this.$refs["annotationUpload"].clearFiles();
            this.annotationFile = file;
        },

        // 全部重置
        handleResetForm() {},

        // method 全选
        handleSelectAllCheckboxMethod() {
            this.checkboxMethods = checkboxMethodList.map((v) => v.value);
        },
        // method 重置
        handleResetCheckboxMethod() {
            this.checkboxMethods = [];
        },

    },
};
</script>

<style lang="less" scoped>
.custom-select {
    width: 80%;
}

.checkbox-method {
    .el-checkbox {
        display: block;
    }
}

.required {
    color: red;
}

/deep/ .el-upload {
    width: 100%;
}

</style>
